import { render, staticRenderFns } from "./customer-package.vue?vue&type=template&id=dc09d574&"
import script from "./customer-package.vue?vue&type=script&lang=js&"
export * from "./customer-package.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports